import { lazy, type ComponentType } from "react";

/**
 * Retry wrapper for lazy imports · handles stale chunk hashes after deploys.
 * Reloads the page once per module; re-throws on second failure.
 */
export function lazyRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  name?: string,
): React.LazyExoticComponent<T> {
  return lazy(() =>
    factory().catch((err) => {
      const key = `chunk-retry-${name || "default"}`;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, "1");
        window.location.reload();
        return new Promise(() => {});
      }
      sessionStorage.removeItem(key);
      throw err;
    }),
  );
}
